export default "__VITE_ASSET__4eb938d4__"